<div class="mb-3 ">
  <app-field-title [titleInfo]="detailInfo" [formControlObj]="formControlObj">
    <input type="text" class="form-control" [formControl]="formControlObj" [name]="detailInfo.title"
      [placeholder]="isOptionLoading ? 'Loading..' :'Add text'" />
  </app-field-title>
</div>